<style scoped>
    .label {
        font-weight: 600;
    }
</style>
<template>
    <div class="">
        <app-overlay-loader v-if="preloader" />
        <div class="card-body" style="margin-top: -4%;">
            <form ref="form" data-url="/crud" :class="{ 'loading-opacity': preloader }">
                <div class="form-group card-with-shadow p-2 mt-3">
                    <div class="row" v-if="contractDetail">
                        <div class="form-group col-md-3">
                            <label for="status" class="label"> {{ $t("status") }}</label>
                            <app-input type="text" v-model="contractDetail.status" disabled="disabled" />
                        </div>

                        <div class="form-group col-md-3">
                            <label for="fiscal_year" class="label"> {{ $t("fiscal_year") }}</label>
                            <app-input type="text" v-model="contractDetail.fiscal_year" disabled="disabled" />
                        </div>

                        <div class="form-group col-md-3">
                            <label for="load_type" class="label"> {{ $t("load_type") }}</label>
                            <app-input type="text" v-model="contractDetail.load_type" disabled="disabled" />
                        </div>
                    
                        <div class="form-group col-md-3">
                            <label for="item_n" class="label"> {{ $t("item_n") }}</label>
                            <app-input type="text" v-model="item_n" disabled="disabled" />
                        </div>

                        <div class="form-group col-md-3">
                            <label for="sales_coord" class="label"> {{ $t("sales_coord") }}</label>
                            <app-input type="text" v-model="contractDetail.sales_coord" disabled="disabled" />
                        </div>

                        <div class="form-group col-md-3">
                            <label for="logistic_coordinator" class="label"> {{ $t("logistic_coordinator") }}</label>
                            <app-input type="text" v-model="contractDetail.logistic_coordinator" disabled="disabled" />
                        </div>

                        <div class="form-group col-md-3">
                            <label for="loads" class="label"> {{ $t("loads") }}</label>
                            <app-input type="text" v-model="contractDetail.loads" disabled="disabled" />
                        </div>

                        <div class="form-group col-md-3">
                            <label for="completed_loads" class="label"> {{ $t("completed_loads") }}</label>
                            <app-input type="text" v-model="contractDetail.completed_loads" disabled="disabled" />
                        </div>
                        <CheckList v-model="checkbox" :list="list" :read=true />
                    </div>
                </div>   
            </form>
        </div>
    </div>
</template>

<script>

import { FormMixin } from '../../../../../core/mixins/form/FormMixin.js';
import { get_data_products, get_data_contract } from '../mixins/api.js';
import { listChek} from '../mixins/functions.js';
import CheckList from '../components/CheckList.vue';

export default {
    name: "contractDetailView",
    mixins: [FormMixin],
    components : { CheckList },
    data() {
        return {
            list: [],
            checkbox: [],
            contractDetail : {},
            preloader : false,
            contractId : null,
            item_n : 0,
        }  
    },
    methods: {
        async loadContractDetails(id) {
            if (id) {
                const respuesta = await get_data_contract(id);
                if (respuesta) {
                    this.mannageContracDetail(respuesta[1]);
                }
            }
        },

        async loadProductsDetails(id) {
			if (id) {
				const respuesta = await get_data_products(id);	
				if (respuesta) {
                    this.item_n = respuesta.length;
				}
			} 
		},

        mannageContracDetail( respuesta ) {
            const detail = {
                status : respuesta.cd_status?.value ?? '',
                fiscal_year : respuesta?.cd_fiscalYear?.value ?? '',
                load_type : respuesta?.cd_loadType?.value ?? '',
                sales_coord : respuesta?.salesCoord?.full_name ?? '',
                logistic_coordinator : respuesta?.logisticCoord?.full_name ?? '',
                loads : respuesta?.cd_loads ?? '',
                completed_loads : respuesta?.cd_loads_completed ?? '',
            }
            this.contractDetail = detail;
            this.checkbox = respuesta?.checkbox ?? [];
        },
    },

    created() {
        this.list = listChek(); // Llamar la función después de la inicialización del componente
    },

    async mounted() { 
        if (this.$route.params.id) {
            this.contractId = this.$route.params.id;
            localStorage.setItem('contractDetailId', this.$route.params.id);
        }else if (localStorage.getItem('contractDetailId')) {
            this.contractId = localStorage.getItem('contractDetailId');
        }
        if (this.contractId) {
            this.preloader = true;
            await this.loadContractDetails(this.contractId);
            await this.loadProductsDetails(this.contractId);
            this.preloader = false;
        }
    },
}
</script>
